import { render } from "./SideMenuButtons.vue?vue&type=template&id=e4496c8a&scoped=true&ts=true"
import script from "./SideMenuButtons.vue?vue&type=script&lang=ts"
export * from "./SideMenuButtons.vue?vue&type=script&lang=ts"

import "./SideMenuButtons.vue?vue&type=style&index=0&id=e4496c8a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4496c8a"]])

export default __exports__